import { httpRequest } from "../../../../utils/HttpRequest";
import { IPage, IPageList } from "../../../../types/FmsTypes";
import { IMarketingRecordDetail, IMarketingRecordFields, IMarketingRecordSearch } from "./allMemberMarketingListTypes";


class AllMemberMarketingListService {
   

    /**
     * 分页查询全员营销记录列表
     * @param insertVo 
     * @returns 
     */
    async page(insertVo: IMarketingRecordSearch) {
        const appInsertUrl = "/auth/marketing-record/findList";
        let ret = await httpRequest.post<IPage<IMarketingRecordDetail>>(appInsertUrl, insertVo);
        return ret;
    }

   
    /**
     * 查询某个全员营销记录
     * @param insertVo
     * @returns 
     */
    async findOne(id: string) {
        const appInsertUrl = `/auth/marketing-record/find/${id}`;
        let ret = await httpRequest.get<IMarketingRecordDetail>(appInsertUrl);
        return ret;
    }

}

export const allMemberMarketingListService = new AllMemberMarketingListService();
